// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('ArticleColorVariantsInfoVO')
export class ArticleColorVariantsInfoVO {

  @JsonProperty('articleNo', 'String')
  public articleNo: string = undefined;

  @JsonProperty('variants', '[ArticleColorVariantVO]')
  public variants: ArticleColorVariantVO[] = [];
}

@JsonObject('ArticleColorVariantVO')
export class ArticleColorVariantVO {
  @JsonProperty('articleNo', 'String')
  public articleNo: string = undefined;

  @JsonProperty('colorId', 'String')
  public colorId: string = undefined;

  @JsonProperty('color', 'String')
  public color: string = undefined;
}
